import { Box, TextField, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import DraggableEntry from './DraggableEntry';

import {
  AccordionContentDto,
  AccordionEntryDetailsDto,
  DEFAULT_ACCORDION_ENTRY,
} from '@act/shared/data-transfer-objects';

interface AccordionSectionFormProps {
  section: AccordionContentDto;
  sectionIndex: number;
  onChange: (section: AccordionContentDto) => void;
  onDeleteEntry: (sectionIndex: number, entryIndex: number) => void;
}

const AccordionSectionForm = ({
  section,
  sectionIndex,
  onChange,
  onDeleteEntry,
}: AccordionSectionFormProps) => {
  const handleAddEntry = () => {
    onChange({
      ...section,
      entries: [
        ...section.entries,
        {
          ...DEFAULT_ACCORDION_ENTRY,
          sortOrder: section.entries.length + 1,
        },
      ],
    });
  };

  const handleMoveEntry = (dragIndex: number, hoverIndex: number) => {
    const dragEntry = section.entries[dragIndex];
    const newEntries = [...section.entries];
    newEntries.splice(dragIndex, 1);
    newEntries.splice(hoverIndex, 0, dragEntry);

    onChange({
      ...section,
      entries: newEntries.map((entry, index) => ({
        ...entry,
        sortOrder: index + 1,
      })),
    });
  };

  const handleEntryChange = (index: number, updatedEntry: unknown) => {
    const newEntries = [...section.entries];
    newEntries[index] = updatedEntry as AccordionEntryDetailsDto;
    onChange({
      ...section,
      entries: newEntries,
    });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <TextField
        label="Section Title"
        value={section.title || ''}
        onChange={e => onChange({ ...section, title: e.target.value })}
        fullWidth
      />

      {section.entries.map((entry, index) => (
        <DraggableEntry
          key={index}
          entry={entry}
          index={index}
          sectionIndex={sectionIndex}
          onMove={handleMoveEntry}
          onChange={handleEntryChange}
          onDelete={() => {
            onDeleteEntry(sectionIndex, index);
          }}
          type="accordion"
        />
      ))}

      <Button
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={handleAddEntry}
      >
        Add Entry
      </Button>
    </Box>
  );
};

export default AccordionSectionForm;
